import React from 'react';
import { FileText, Download } from 'lucide-react';
interface DownloadCardProps {
  title: string;
  type: string;
  size: string;
  category?: string;
}
export function DownloadCard({
  title,
  type,
  size,
  category
}: DownloadCardProps) {
  return <div className="flex items-center justify-between bg-white p-5 border border-club-border rounded-sm hover:border-club-gold transition-colors cursor-pointer group" data-id="element-121">
      <div className="flex items-start gap-4" data-id="element-122">
        <div className="bg-club-canvasAlt p-3 rounded-sm text-club-gold" data-id="element-123">
          <FileText size={24} data-id="element-124" />
        </div>
        <div data-id="element-125">
          {category && <span className="text-xs font-semibold uppercase tracking-wider text-club-ink/50 mb-1 block" data-id="element-126">
              {category}
            </span>}
          <h4 className="font-medium text-club-ink group-hover:text-club-green transition-colors" data-id="element-127">
            {title}
          </h4>
          <p className="text-xs text-club-ink/60 mt-1" data-id="element-128">
            {type} • {size}
          </p>
        </div>
      </div>
      <button className="p-2 text-club-ink/40 group-hover:text-club-gold transition-colors bg-club-canvasAlt rounded-full" data-id="element-129">
        <Download size={18} data-id="element-130" />
      </button>
    </div>;
}